import { apiSend, apiSendJson, apiSendJsonAndFiles } from "@/api/apicommon"

export default {
    async getCurrentHproEntries(requestedIsoDateTime: string) {
        const method = "POST"
        const endpoint = "/office/getCurrentHproEntries/"
        const json = {
            "requestedIsoDateTime": requestedIsoDateTime,
        }
        return await apiSendJson(method, endpoint, json)
    },
    async setCurrentEntryId(entryId:string) {
        const method = "POST"
        const endpoint = "/office/setCurrentEntryId/"
        const json = {
            "entryId": entryId
        }
        return await apiSendJson(method, endpoint, json)
    },
    async getAllPatientPwr() {
        const method = "POST"
        const endpoint = "/office/getAllPatientPwr/"
        const json = {
        }
        return await apiSendJson(method, endpoint, json)
    },
    async createNewCurrentEntry(patientPwrId:string, instituteWithRoleId: string, healthProId: string) {
        const method = "POST"
        const endpoint = "/patients/"+patientPwrId+ "/consultations"
        const json = {
            "instituteWithRoleId": instituteWithRoleId,
            "healthProId": healthProId
        }
        return await apiSendJson(method, endpoint, json)
    },
    async startEntryForPlannedAppointment(appointmentId:string) {
        const method = "POST"
        const endpoint = "/office/startEntryForPlannedAppointment/"
        const json = {
            "appointmentId": appointmentId
        }
        return await apiSendJson(method, endpoint, json)
    },
    async getAppointmentsForHealthGroupMember(healthGroupMemberId:string, appointementDay:string) {
        const method = "POST"
        const endpoint = "/office/getAppointmentsForHealthGroupMember/"
        const json = {
            "healthGroupMemberId": healthGroupMemberId,
            "appointementDay": appointementDay,
        }
        return await apiSendJson(method, endpoint, json)
    },
    async waitingRoomAppointmentsForIwr(instituteWithRoleId:string, appointementDay:string) {
        const method = "POST"
        const endpoint = "/office/waitingRoomAppointmentsForIwr/"
        const json = {
            "instituteWithRoleId": instituteWithRoleId,
            "appointementDay": appointementDay,
        }
        return await apiSendJson(method, endpoint, json)
    },
    async getSinglePatientPwrWithDetails(pwrPatientId: string) {
        const method = "POST"
        const endpoint = "/office/getSinglePatientPwrWithDetails/"
        const json = {
            "pwrPatientId": pwrPatientId,
        }
        return await apiSendJson(method, endpoint, json)
    },
    async getMatchingInvoicesOfFinancialGroup(searchString: string, financialGroupId:string) {
        const method = "POST"
        const endpoint = "/office/getMatchingInvoicesOfFinancialGroup/"
        const json = {
            "searchString": searchString,
            "financialGroupId": financialGroupId,
        }
        return await apiSendJson(method, endpoint, json)
    },
    async getFinancialGroups(personWithRoleId:string) {
        const method = "POST"
        const endpoint = "/office/getFinancialGroups/"
        const json = {
            "personWithRoleId": personWithRoleId,
        }
        return await apiSendJson(method, endpoint, json)
    },
    async validateTask(taskId:string) {
        const method = "POST"
        const endpoint = "/office/validateTask/"
        const json = {
            "taskId": taskId,
        }
        return await apiSendJson(method, endpoint, json)
    },
    async unvalidateTask(taskId:string) {
        const method = "POST"
        const endpoint = "/office/unvalidateTask/"
        const json = {
            "taskId": taskId,
        }
        return await apiSendJson(method, endpoint, json)
    },
    async updateTaskPriorityType(taskId:string, taskPriorityType:string) {
        const method = "POST"
        const endpoint = "/office/updateTaskPriorityType/"
        const json = {
            "taskId": taskId,
            "taskPriorityType": taskPriorityType,
        }
        return await apiSendJson(method, endpoint, json)
    },
    async updateHasAlert(taskId:string, hasAlert:string) {
        const method = "POST"
        const endpoint = "/office/updateHasAlert/"
        const json = {
            "taskId": taskId,
            "hasAlert": hasAlert,
        }
        return await apiSendJson(method, endpoint, json)
    },
    async updateIsPrivate(taskId:string, isPrivate:string) {
        const method = "POST"
        const endpoint = "/office/updateIsPrivate/"
        const json = {
            "taskId": taskId,
            "isPrivate": isPrivate,
        }
        return await apiSendJson(method, endpoint, json)
    },
    async updateShowDate(taskId:string, showDate:string) {
        const method = "POST"
        const endpoint = "/office/updateShowDate/"
        const json = {
            "taskId": taskId,
            "showDate": showDate,
        }
        return await apiSendJson(method, endpoint, json)
    },
    async updateTaskBoxModuleType(taskBoxId:string, taskBoxModuleType:string) {
        const method = "POST"
        const endpoint = "/office/updateTaskBoxModuleType/"
        const json = {
            "taskBoxId": taskBoxId,
            "taskBoxModuleType": taskBoxModuleType,
        }
        return await apiSendJson(method, endpoint, json)
    },
    async updateTaskBoxTitle(taskBoxId:string, taskBoxTitle:string) {
        const method = "POST"
        const endpoint = "/office/updateTaskBoxTitle/"
        const json = {
            "taskBoxId": taskBoxId,
            "taskBoxTitle": taskBoxTitle,
        }
        return await apiSendJson(method, endpoint, json)
    },
    async switchTaskBox(taskId:string, taskBoxId:string) {
        const method = "POST"
        const endpoint = "/office/switchTaskBox/"
        const json = {
            "taskId": taskId,
            "taskBoxId": taskBoxId,
        }
        return await apiSendJson(method, endpoint, json)
    },
    async switchTaskBoxToHealthcare(taskId:string) {
        const method = "POST"
        const endpoint = "/office/switchTaskBoxToHealthcare/"
        const json = {
            "taskId": taskId,
        }
        return await apiSendJson(method, endpoint, json)
    },
    async addNoteToTask(taskId:string, noteContent:string) {
        const method = "POST"
        const endpoint = "/office/addNoteToTask/"
        const json = {
            "taskId": taskId,
            "noteContent": noteContent,
        }
        return await apiSendJson(method, endpoint, json)
    },
    async createTask(taskBoxId:string, taskInfo:string, taskPriorityType:string, pwrPatientId:string) {
        const method = "POST"
        const endpoint = "/office/createTask/"
        const json = {
            "taskBoxId": taskBoxId,
            "taskInfo": taskInfo,
            "taskPriorityType": taskPriorityType,
            "pwrPatientId": pwrPatientId,
        }
        return await apiSendJson(method, endpoint, json)
    },
    async createTaskHealthcare(taskInfo:string, taskPriorityType:string, pwrPatientId:string) {
        const method = "POST"
        const endpoint = "/office/createTaskHealthcare/"
        const json = {
            "taskInfo": taskInfo,
            "taskPriorityType": taskPriorityType,
            "pwrPatientId": pwrPatientId,
        }
        return await apiSendJson(method, endpoint, json)
    },
    async createTaskBox(taskBoxTitle:string, taskBoxModuleType:string, isAssignee: boolean) {
        const method = "POST"
        const endpoint = "/office/createTaskBox/"
        const json = {
            "taskBoxTitle": taskBoxTitle,
            "taskBoxModuleType": taskBoxModuleType,
            "isAssignee": isAssignee
        }
        return await apiSendJson(method, endpoint, json)
    },

    async deactivateTaskBox(taskBoxId:string) {
        const method = "POST"
        const endpoint = "/office/deactivateTaskBox/"
        const json = {
            "taskBoxId": taskBoxId,
        }
        return await apiSendJson(method, endpoint, json)
    },
    async createTwoPersonTaskBox(appUserId: string) {
        const method = "POST"
        const endpoint = "/office/createTwoPersonTaskBox/"
        const json = {
            "appUserId": appUserId
        }
        return await apiSendJson(method, endpoint, json)
    },
    async setTaskBoxParticipant(appUserId: string, taskBoxId: string, isAssignee: boolean) {
        const method = "POST"
        const endpoint = "/office/setTaskBoxParticipant/"
        const json = {
            "appUserId": appUserId,
            "taskBoxId": taskBoxId,
            "isAssignee": isAssignee
        }
        return await apiSendJson(method, endpoint, json)
    },
    async deleteTaskBoxParticipant(appUserId: string, taskBoxId: string) {
        const method = "POST"
        const endpoint = "/office/deleteTaskBoxParticipant/"
        const json = {
            "appUserId": appUserId,
            "taskBoxId": taskBoxId
        }
        return await apiSendJson(method, endpoint, json)
    },
    async getTasksAndNotesForPatient(personWithRoleId:string) {
        const method = "POST"
        const endpoint = "/office/getTasksAndNotesForPatient/"
        const json = {
            "personWithRoleId": personWithRoleId,
        }
        return await apiSendJson(method, endpoint, json)
    },
    async setTaskNotesAsRead(taskId:string) {
        const method = "POST"
        const endpoint = "/office/setTaskNotesAsRead/"
        const json = {
            "taskId": taskId,
        }
        return await apiSendJson(method, endpoint, json)
    },   
    async updateAppointmentInfo(appointmentId:string, appointmentInfo:string) {
        const method = "POST"
        const endpoint = "/office/updateAppointmentInfo/"
        const json = {
            "appointmentId": appointmentId,
            "appointmentInfo": appointmentInfo,
        }
        return await apiSendJson(method, endpoint, json)
    },
    async updateAppointmentLocation(appointmentId:string, appointmentLocation:string) {
        const method = "POST"
        const endpoint = "/office/updateAppointmentLocation/"
        const json = {
            "appointmentId": appointmentId,
            "appointmentLocation": appointmentLocation,
        }
        return await apiSendJson(method, endpoint, json)
    },
    async addAppointmentByLocation(pwrPatientId:string, appointmentLocation:string) {
        const method = "POST"
        const endpoint = "/office/addAppointmentByLocation/"
        const json = {
            "pwrPatientId": pwrPatientId,
            "appointmentLocation": appointmentLocation,
        }
        return await apiSendJson(method, endpoint, json)
    },
    async updateAppointmentHealthGroupMember(appointmentId:string, healthGroupMemberId:string) {
        const method = "POST"
        const endpoint = "/office/updateAppointmentHealthGroupMember/"
        const json = {
            "appointmentId": appointmentId,
            "healthGroupMemberId": healthGroupMemberId,
        }
        return await apiSendJson(method, endpoint, json)
    },
    async updateAppointmentPatient(appointmentId:string, pwrPatientId:string) {
        const method = "POST"
        const endpoint = "/office/updateAppointmentPatient/"
        const json = {
            "appointmentId": appointmentId,
            "pwrPatientId": pwrPatientId,
        }
        return await apiSendJson(method, endpoint, json)
    },
    async addEmailToPwr(personWithRoleUuid: string, emailAddress: string, note: string) {
        const method = "POST"
        const endpoint = "/office/addEmailToPwr/"
        const json = {
            "personWithRoleUuid": personWithRoleUuid,
            "emailAddress" : emailAddress,
            "note" : note,
        }
        return await apiSendJson(method, endpoint, json)
    },
    async addPhoneToPwr(personWithRoleUuid: string, phonePrefix: string, number: number, isMobile: boolean, note: string) {
        const method = "POST"
        const endpoint = "/office/addPhoneToPwr/"
        const json = {
            "personWithRoleUuid": personWithRoleUuid,
            "phonePrefix": phonePrefix,
            "number": number,
            "isMobile": isMobile,
            "note" : note,
        }
        return await apiSendJson(method, endpoint, json)
    },
    async addEmailToIwr(instituteWithRoleUuid: string, emailAddress: string) {
        const method = "POST"
        const endpoint = "/office/addEmailToIwr/"
        const json = {
            "instituteWithRoleUuid": instituteWithRoleUuid,
            "emailAddress": emailAddress,
        }
        return await apiSendJson(method, endpoint, json)
    },
    async addPhoneToIwr(instituteWithRoleUuid: string, phonePrefix: string, number: string, isMobile: boolean) {
        const method = "POST"
        const endpoint = "/office/addPhoneToIwr/"
        const json = {
            "instituteWithRoleUuid": instituteWithRoleUuid,
            "phonePrefix": phonePrefix,
            "number": number,
            "isMobile": isMobile,
        }
        return await apiSendJson(method, endpoint, json)
    },
    async updateIwrAddressStreet(instituteAddressId: string, street: string) {
        const method = "POST"
        const endpoint = "/office/updateIwrAddressStreet/"
        const json = {
            "instituteAddressId": instituteAddressId,
            "street": street,
        }
        return await apiSendJson(method, endpoint, json)
    },
    async updateIwrAddressPostalCode(instituteAddressId: string, postalCode: string) {
        const method = "POST"
        const endpoint = "/office/updateIwrAddressPostalCode/"
        const json = {
            "instituteAddressId": instituteAddressId,
            "postalCode": postalCode,
        }
        return await apiSendJson(method, endpoint, json)
    },
    async updateIwrAddressLocality(instituteAddressId: string, locality: string) {
        const method = "POST"
        const endpoint = "/office/updateIwrAddressLocality/"
        const json = {
            "instituteAddressId": instituteAddressId,
            "locality": locality,
        }
        return await apiSendJson(method, endpoint, json)
    },
    async updateIwrAddressCountry(instituteAddressId: string, country: string) {
        const method = "POST"
        const endpoint = "/office/updateIwrAddressCountry/"
        const json = {
            "instituteAddressId": instituteAddressId,
            "country": country,
        }
        return await apiSendJson(method, endpoint, json)
    },
    async copyPhoneToPwr(personWithRoleId: string, personPhoneId: string) {
        const method = "POST"
        const endpoint = "/office/copyPhoneToPwr/"
        const json = {
            "personWithRoleId": personWithRoleId,
            "personPhoneId": personPhoneId,
        }
        return await apiSendJson(method, endpoint, json)
    },
    async copyEmailToPwr(personWithRoleId: string, personEmailId: string) {
        const method = "POST"
        const endpoint = "/office/copyEmailToPwr/"
        const json = {
            "personWithRoleId": personWithRoleId,
            "personEmailId": personEmailId,
        }
        return await apiSendJson(method, endpoint, json)
    }, 
    async copyAddressToPwr(personWithRoleId: string, personAddressId: string) {
        const method = "POST"
        const endpoint = "/office/copyAddressToPwr/"
        const json = {
            "personWithRoleId": personWithRoleId,
            "personAddressId": personAddressId,
        }
        return await apiSendJson(method, endpoint, json)
    },         
    async addPwrPersonToPwrPatient(pwrPatientId: string, pwrPersonId: string) {
        const method = "POST"
        const endpoint = "/office/addPwrPersonToPwrPatient/"
        const json = {
            "pwrPatientId": pwrPatientId,
            "pwrPersonId": pwrPersonId,
        }
        return await apiSendJson(method, endpoint, json)
    },
    async updatePwrFirstName(personWithRoleId: string, firstName: string) {
        const method = "POST"
        const endpoint = "/office/updatePwrFirstName/"
        const json = {
            "personWithRoleId": personWithRoleId,
            "firstName": firstName
        }
        return await apiSendJson(method, endpoint, json)
    },   
    async addLanguageToPwr(personWithRoleId: string, isoLanguage: string) {
        const method = "POST"
        const endpoint = "/office/addLanguageToPwr/"
        const json = {
            "personWithRoleId": personWithRoleId,
            "isoLanguage": isoLanguage
        }
        return await apiSendJson(method, endpoint, json)
    },
    async removeLanguageFromPwr(personWithRoleId: string, isoLanguage: string) {
        const method = "POST"
        const endpoint = "/office/removeLanguageFromPwr/"
        const json = {
            "personWithRoleId": personWithRoleId,
            "isoLanguage": isoLanguage
        }
        return await apiSendJson(method, endpoint, json)
    },    
    async updatePwrLastName(personWithRoleId: string, lastName: string) {
        const method = "POST"
        const endpoint = "/office/updatePwrLastName/"
        const json = {
            "personWithRoleId": personWithRoleId,
            "lastName": lastName
        }
        return await apiSendJson(method, endpoint, json)
    },
    async updatePwrNameAtBirth(personWithRoleId: string, nameAtBirth: string) {
        const method = "POST"
        const endpoint = "/office/updatePwrNameAtBirth/"
        const json = {
            "personWithRoleId": personWithRoleId,
            "nameAtBirth": nameAtBirth
        }
        return await apiSendJson(method, endpoint, json)
    },
    async updatePwrBirthDate(personWithRoleId: string, birthDate: string) {
        const method = "POST"
        const endpoint = "/office/updatePwrBirthDate/"
        const json = {
            "personWithRoleId": personWithRoleId,
            "birthDate": birthDate
        }
        return await apiSendJson(method, endpoint, json)
    },
    async updatePwrGenderType(personWithRoleId: string, genderType: string) {
        const method = "POST"
        const endpoint = "/office/updatePwrGenderType/"
        const json = {
            "personWithRoleId": personWithRoleId,
            "genderType": genderType
        }
        return await apiSendJson(method, endpoint, json)
    },  
    async updatePwrBiologicalSexType(personWithRoleId: string, biologicalSexType: string) {
        const method = "POST"
        const endpoint = "/office/updatePwrBiologicalSexType/"
        const json = {
            "personWithRoleId": personWithRoleId,
            "biologicalSexType": biologicalSexType
        }
        return await apiSendJson(method, endpoint, json)
    },             
    async updateInvoiceInfo(invoiceId: string, info: string) {
        const method = "POST"
        const endpoint = "/office/updateInvoiceInfo/"
        const json = {
            "invoiceId": invoiceId,
            "info": info,
        }
        return await apiSendJson(method, endpoint, json)
    },
    async deleteTransaction(transactionId: string) {
        const method = "POST"
        const endpoint = "/office/deleteTransaction/"
        const json = {
            "transactionId": transactionId
        }
        return await apiSendJson(method, endpoint, json)
    },
    async createInvoiceReminders(invoiceIds: string[], reminderDate: string) {
        const method = "POST"
        const endpoint = "/office/createInvoiceReminders/"
        const json = {
            "invoiceIds": invoiceIds,
            "reminderDate": reminderDate,
        }
        return await apiSendJson(method, endpoint, json)
    },
    async createTpSheet(invoiceIds: string[], tpCreationDate?: string) {
        const method = "POST"
        const endpoint = "/office/createTpSheet"
        const json = {
            "invoiceIds": invoiceIds,
            "tpCreationDate": tpCreationDate
        }
        return await apiSendJson(method, endpoint, json)
    },
    async createTpSocialSheet(invoiceIds: string[], tpCreationDate?: string) {
        const method = "POST"
        const endpoint = "/office/createTpSocialSheet"
        const json = {
            "invoiceIds": invoiceIds,
            "tpCreationDate": tpCreationDate
        }
        return await apiSendJson(method, endpoint, json)
    },
    async getInvoicesPdfStream(invoiceIds: string[]) {
        const method = "POST"
        const endpoint = "/office/getInvoicesPdfStream"
        const json = {
            invoiceIds: invoiceIds
        }
        const isBinary = true
        return await apiSendJson(method, endpoint, json, isBinary)
    },
    async getInvoicesWithRemindersPdfStream(invoiceIds: string[]) {
        const method = "POST"
        const endpoint = "/office/getInvoicesWithRemindersPdfStream"
        const json = {
            invoiceIds: invoiceIds
        }
        const isBinary = true
        return await apiSendJson(method, endpoint, json, isBinary)
    },
    async getTpInvoicesPdfStream(tpUuid: string) {
        const method = "POST"
        const endpoint = "/office/getTpInvoicesPdfStream"
        const json = {
            "tpUuid": tpUuid
        }
        const isBinary = true
        return await apiSendJson(method, endpoint, json, isBinary)
    },
    async getTpPdfStream(tpUuid: string) {
        const method = "POST"
        const endpoint = "/office/getTpPdfStream/"
        const json = {
            "tpUuid": tpUuid
        }
        const isBinary = true
        return await apiSendJson(method, endpoint, json, isBinary)
    },    
    async updateTransactionAmount(transactionId: string, amount: string) {
        const method = "POST"
        const endpoint = "/office/updateTransactionAmount/"
        const json = {
            "transactionId": transactionId,
            "amount": amount
        }
        return await apiSendJson(method, endpoint, json)
    },
    async updateTransactionDate(transactionId: string, transactionDate: string) {
        const method = "POST"
        const endpoint = "/office/updateTransactionDate/"
        const json = {
            "transactionId": transactionId,
            "transactionDate": transactionDate
        }
        return await apiSendJson(method, endpoint, json)
    },
    async finalizeInvoiceToPid(financialChannelId: string, invoiceId: string, paymentDate: string) {
        const method = "POST"
        const endpoint = "/office/finalizeInvoiceToPid/"
        const json = {
            "financialChannelId": financialChannelId,
            "invoiceId": invoiceId,
            "paymentDate": paymentDate,
        }
        return await apiSendJson(method, endpoint, json)
    },  
    async addImportFilesAsTasks(taskBoxId: string, files: File[]) {
        const method = "POST"
        const endpoint = "/office/addImportFilesAsTasks/"
        const json = {
            "taskBoxId": taskBoxId,
        }
        return await apiSendJsonAndFiles(method, endpoint, json, files)
    },
    async autoImportXmlFiles(files: File[]) {
        const method = "POST"
        const endpoint = "/office/autoImportXmlFiles/"
        const json = {
        }
        return await apiSendJsonAndFiles(method, endpoint, json, files)
    },
    async getTaskImportFileStream(taskId: string) {
        const method = "POST"
        const endpoint = "/office/getTaskImportFileStream/"
        const json = {
            "taskId": taskId
        }
        const isBinary = true
        return await apiSendJson(method, endpoint, json, isBinary)
    },
    async addPwrPatientFromCnsNumberToTask(taskId: string, cnsNumber: string) {
        const method = "POST"
        const endpoint = "/office/addPwrPatientFromCnsNumberToTask/"
        const json = {
            "taskId": taskId,
            "cnsNumber": cnsNumber
        }
        return await apiSendJson(method, endpoint, json)
    },    
    async updateImportFileOriginalExpression(taskId: string, originalExpression: string) {
        const method = "POST"
        const endpoint = "/office/updateImportFileOriginalExpression/"
        const json = {
            "taskId": taskId,
            "originalExpression": originalExpression
        }
        return await apiSendJson(method, endpoint, json)
    },
    async updateImportFileResultDate(taskId: string, resultDate: string) {
        const method = "POST"
        const endpoint = "/office/updateImportFileResultDate/"
        const json = {
            "taskId": taskId,
            "resultDate": resultDate
        }
        return await apiSendJson(method, endpoint, json)
    },
    async updateImportPwrPatient(taskId: string, pwrPatientId: string) {
        const method = "POST"
        const endpoint = "/office/updateImportPwrPatient/"
        const json = {
            "taskId": taskId,
            "pwrPatientId": pwrPatientId
        }
        return await apiSendJson(method, endpoint, json)
    },
    async integrateRenamedResultFile(taskId: string) {
        const method = "POST"
        const endpoint = "/office/integrateRenamedResultFile/"
        const json = {
            "taskId": taskId
        }
        return await apiSendJson(method, endpoint, json)
    },
    async getAllPrecompleteInvoices(personWithRoleId: string, pageNumber: number, size: number, invoiceRef?: string) {
        const method = "GET"
        const refParam = invoiceRef ? `&invoice_ref=${encodeURIComponent(invoiceRef)}` : ""
        const endpoint = `/office/precomplete-invoices?personWithRoleId=${personWithRoleId}&page=${pageNumber}&size=${size}${refParam}`
        return await apiSend(method, endpoint)
    },
    async finalizeInvoiceToUnpaid(invoiceId: string) {
        const method = "POST"
        const endpoint = "/office/finalizeInvoiceToUnpaid/"
        const json = {
            "invoiceId": invoiceId,
        }
        return await apiSendJson(method, endpoint, json)
    },
    async addTransaction(sourceFinancialChannelId: string, financialChannelId: string, invoiceId: string, transactionDate: string, amount: string) {
        const method = "POST"
        const endpoint = "/office/addTransaction/"
        const json = {
            "sourceFinancialChannelId": sourceFinancialChannelId,
            "financialChannelId": financialChannelId,
            "invoiceId": invoiceId,
            "transactionDate": transactionDate,
            "amount": amount,
        }
        return await apiSendJson(method, endpoint, json)
    },
    async getTransactionListCsv(financialGroupId:string) {
        const method = "POST"
        const endpoint = "/office/getTransactionListCsv/"
        const json = {
            "financialGroupId": financialGroupId,
        }
        return await apiSendJson(method, endpoint, json, true, true)
    },
    async createLuBilledActListCsv(financialGroupId:string) {
        const method = "POST"
        const endpoint = "/office/createLuBilledActListCsv/"
        const json = {
            "financialGroupId": financialGroupId,
        }
        return await apiSendJson(method, endpoint, json, true, true)
    },
    async createLuBillListCsv(financialGroupId:string) {
        const method = "POST"
        const endpoint = "/office/createLuBillListCsv/"
        const json = {
            "financialGroupId": financialGroupId,
        }
        return await apiSendJson(method, endpoint, json, true, true)
    },
    async exportForBob50(financialGroupId:string) {
        const method = "POST"
        const endpoint = "/office/exportForBob50/"
        const json = {
            "financialGroupId": financialGroupId,
        }
        return await apiSendJson(method, endpoint, json, true, true)
    },
}
